import { api, ReactQueryOptions, RouterInputs } from '@api'
import { staleTimeIndex } from '@specs/constants'
import { useSession } from '@shared/hooks/useSession'

type optionsType = ReactQueryOptions['ToyManager']['isCollectionBonusToyCollected']
type inputType = RouterInputs['ToyManager']['isCollectionBonusToyCollected']

export const useIsCollectionBonusToyCollected = (input: inputType, options?: optionsType) => {
    const { status } = useSession()

    return api.ToyManager.isCollectionBonusToyCollected.useQuery(input, {
        ...options,
        queryKey: ['ToyManager.isCollectionBonusToyCollected', input],
        enabled: status === 'authenticated' && options?.enabled,
        refetchOnWindowFocus: false,
        staleTime: 24 * 60 * 60 * 1000 * staleTimeIndex, // 1 day
    })
}
